import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Instance, LoggedUserService } from '@improver/infrastructure/auth-data-layer';
import { ThemeInstanceService } from '@improver/infrastructure/layout-data-layer';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

export const themeResolver: ResolveFn<Record<string, string>> = () => {
  const themeService: ThemeInstanceService = inject(ThemeInstanceService);
  const logged: LoggedUserService = inject(LoggedUserService);

  return logged
    .getCurrentInstance()
    .pipe(
      switchMap(
        (instance: Instance): Observable<Record<string, string>> => (instance ? themeService.setLayoutVariables(instance.id) : of({}))
      )
    );
};
